import {
  LLMModelTypeEnum,
  ModuleIOValueTypeEnum,
  ModuleInputKeyEnum,
  ModuleOutputKeyEnum,
  ModuleTemplateTypeEnum,
} from '../../constants';
import {
  FlowNodeInputTypeEnum,
  FlowNodeOutputTypeEnum,
  FlowNodeTypeEnum,
} from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import {
  Input_Template_History,
  Input_Template_Switch,
  Input_Template_UserChatInput,
  Input_Template_AiModel,
} from '../input';

export const AiQueryExtensionModule: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.aiChat,
  templateType: ModuleTemplateTypeEnum.other,
  flowType: FlowNodeTypeEnum.queryExtension,
  avatar: '/imgs/module/cfr.svg',
  name: '问题优化',
  description:
    '使用问题优化功能，可以提高知识库连续对话时搜索的精度。使用该功能后，会先利用 AI 根据上下文构建一个或多个新的检索词，这些检索词更利于进行知识库搜索。该模块已内置在知识库搜索模块中，如果您仅进行一次知识库搜索，可直接使用知识库内置的补全功能。',
  inputs: [
    Input_Template_Switch,
    {
      ...Input_Template_AiModel,
      llmModelType: LLMModelTypeEnum.queryExtension,
    },
    {
      key: ModuleInputKeyEnum.aiSystemPrompt,
      type: FlowNodeInputTypeEnum.textarea,
      label: '对话背景描述',
      max: 300,
      valueType: ModuleIOValueTypeEnum.string,
      description: '描述当前对话的范围，便于AI为当前问题进行补全和扩展。填写的内容，通常为该助手',
      placeholder: `例如:
关于 python 的介绍和使用等问题。
当前对话与游戏《GTA5》有关。`,
      showTargetInApp: true,
      showTargetInPlugin: true,
    },
    { ...Input_Template_History, required: true, type: FlowNodeInputTypeEnum.numberInput },
    Input_Template_UserChatInput,
  ],
  outputs: [
    {
      key: ModuleOutputKeyEnum.text,
      label: '优化结果',
      description:
        '以字符串数组的形式输出，可将该结果直接连接到“知识库搜索”的“用户问题”中，建议不要连接到“AI对话”的“用户问题”中',
      valueType: ModuleIOValueTypeEnum.string,
      type: FlowNodeOutputTypeEnum.source,
      targets: [],
    },
  ],
};
